import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import PayrollTable from './PayrollTable'

class PayrollReport extends React.Component {

  static propTypes = {
    teamId: PropTypes.string.isRequired,
    startDateStr:  PropTypes.string,
    endDateStr: PropTypes.string,
    selectedWorkers:  PropTypes.array
  }

  constructor(props) {
    super(props)
    this.state = {
      startDateStr: props.startDateStr,
      endDateStr: props.endDateStr,
      selectedWorkers: this.props.selectedWorkers
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.startDateStr !== nextProps.startDateStr
      || this.props.endDateStr !== nextProps.endDateStr
      || this.props.selectedWorkers !== nextProps.selectedWorkers) {
      this.setState({
        startDateStr: nextProps.startDateStr,
        endDateStr: nextProps.endDateStr,
        selectedWorkers: nextProps.selectedWorkers
      })
    }
  }

  render() {
    return (
      <div style={styles.container}>
        <div style={styles.tables}>
          { this.state.selectedWorkers.map(worker =>
            <PayrollTable
              key={worker.userId}
              startDateStr={this.state.startDateStr}
              endDateStr={this.state.endDateStr}
              workerId={worker.userId} />)
          }
        </div>
      </div>
    )
  }

}

const styles = {
  container: {
    padding: 24,
    overflow: 'auto',
    flexGrow: 1,
    alignItems: 'stretch'
  },
  tables: {
    flex: 1,
    flexDirection: 'column'
  }
}

export default connect(state => ({ teamId: state.firebase.team.metadata.value.id }))(PayrollReport)



// WEBPACK FOOTER //
// ./src/reports/payroll/PayrollReport.js